var exports = {
  "lI": "DateOfBirthField.module__fieldset___YTZLTm",
  "_A": "DateOfBirthField.module__labelContainer___YTZLTm",
  "o1": "DateOfBirthField.module__legend___YTZLTm",
  "$K": "DateOfBirthField.module__inputsContainer___YTZLTm",
  "EN": "DateOfBirthField.module__fieldsRow___YTZLTm",
  "tZ": "DateOfBirthField.module__monthField___YTZLTm",
  "bc": "DateOfBirthField.module__dayField___YTZLTm",
  "Y9": "DateOfBirthField.module__yearField___YTZLTm",
  "kc": "DateOfBirthField.module__errorText___YTZLTm",
  "Kd": "DateOfBirthField.module__nativeDateInput___YTZLTm",
};

module.exports = exports;
